/* eslint-disable */

/** unique or primary key constraints on table "argo.log" */
export enum ArgoLogConstraint {
  /** unique or primary key constraint on columns "log_id" */
  LogPkey = 'log_pkey'
}

/** select columns of table "argo.log" */
export enum ArgoLogSelectColumn {
  /** column name */
  Category = 'category',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  Message = 'message',
  /** column name */
  Meta = 'meta',
  /** column name */
  Source = 'source'
}

/** update columns of table "argo.log" */
export enum ArgoLogUpdateColumn {
  /** column name */
  Category = 'category',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  Message = 'message',
  /** column name */
  Meta = 'meta',
  /** column name */
  Source = 'source'
}

